import React from "react";
import { motion } from "framer-motion";

const Particle = ({ emoji, x, y, delay, duration }) => {
  return (
    <motion.div
      className="absolute text-2xl pointer-events-none"
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
      initial={{ opacity: 0, scale: 0.5, y: 50 }}
      animate={{
        opacity: [0, 1, 1, 0],
        scale: [0.5, 1.2, 1],
        y: [50, -20, -50],
        x: [0, Math.random() * 20 - 10],
      }}
      transition={{
        duration: duration || 6,
        delay: delay || 0,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
      }}
    >
      {emoji}
    </motion.div>
  );
};

export default Particle;
